import _ from 'lodash';

export default function formatDocumentTableData(intl, documentsData, keyword, translator) {
    const filterDocuments = (documents) => {
        if (_.isEmpty(keyword)) {
            return documents;
        }

        return _.filter(documents, (document) => {           
            
            const filetedDocument = _.includes(document.name.toLocaleLowerCase(),keyword.toLocaleLowerCase()) ||
                                    _.includes(document.dateModified.toLocaleLowerCase(),keyword.toLocaleLowerCase()) ||
                                    _.includes(document.numOfPages.toString(),keyword) ||
                                    _.includes(document.documentType.toLocaleLowerCase(),keyword.toLocaleLowerCase()); 
            
            return filetedDocument;
        });
    };
    if (!_.isEmpty(documentsData)) {
        const documents = documentsData.map((documentsInfo) => {
            const documentDateModified = intl.formatDate(new Date(documentsInfo.dateModified), { year: 'numeric', month: 'short', day: 'numeric' });
            return {
                name: documentsInfo.name,
                dateModified: documentDateModified,
                remove: '',
                sessionID: documentsInfo.sessionID,
                publicID: documentsInfo.publicID,
                numOfPages: documentsInfo.numOfPages,
                documentType: translator({ id: `typekey.DocumentType.${documentsInfo.documentType}` })
            };
        });
        return filterDocuments(documents);
    }
    return documentsData;
}
